// const { default: Swiper } = require("swiper");

const bgRed = document.querySelector(".bg-red");
const bgBlue = document.querySelector(".bg-blue");
const backgrounds = [bgRed, bgBlue];

const swiper = new Swiper(".swiper-distribuidores", {
  // loop: true,
  effect: "fade",

  fadeEffect: {
    crossFade: true,
  },
  pagination: {
    el: ".swiper-pagination",
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  on: {
    init() {
      updateBackground(this, { animate: false });
    },
    slideChangeTransitionStart() {
      updateBackground(this, { animate: true });
    },
  },
});

function getBackgroundByIndex(swiper) {
  const slideIndex = swiper.realIndex ?? swiper.activeIndex;
  return backgrounds[slideIndex % backgrounds.length];
}

function updateBackground(swiper, { animate = true } = {}) {
  const activeBackground = getBackgroundByIndex(swiper);
  const inactiveBackground = backgrounds.find((bg) => bg !== activeBackground);

  backgrounds.forEach((bg) => bg.classList.toggle("active", bg === activeBackground));

  gsap.killTweensOf(backgrounds);
  gsap.set(inactiveBackground, { clipPath: "circle(150% at 50% 50%)" });
  gsap.set(activeBackground, { clipPath: "circle(0% at 50% 50%)" });

  if (!animate) {
    gsap.set(activeBackground, { clipPath: "circle(150% at 50% 50%)" });
    return;
  }

  gsap.to(activeBackground, {
    clipPath: "circle(150% at 50% 50%)",
    duration: 0.6,
    ease: "slow(0.7, 0.7, false)",
    overwrite: true,
  });
}

const floatingImages = gsap.utils.toArray(".img-floating");

floatingImages.forEach((img, index) => {
  gsap.to(img, {
    y: -20,
    duration: 2 + index * 0.2,
    repeat: -1,
    yoyo: true,
    ease: "sine.inOut",
    delay: index * 0.3,
  });
});

let swiperMotivosInstance = null;

function initSwiperMotivos() {
  const mediaQuery = window.matchMedia("(min-width: 576px)");

  function handleBreakpoint(e) {
    if (e.matches) {
      if (!swiperMotivosInstance) {
        swiperMotivosInstance = new Swiper(".swiper-motivos", {
          slidesPerView: "auto",
          direction: "horizontal",
          loop: true,
          spaceBetween: 35,
          pagination: {
            el: ".swiper-pagination.distribuidores",
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          scrollbar: {
            el: ".swiper-scrollbar",
          },
        });
      }
    } else {
      if (swiperMotivosInstance) {
        swiperMotivosInstance.destroy(true, true);
        swiperMotivosInstance = null;
      }
    }
  }

  handleBreakpoint(mediaQuery);
  mediaQuery.addEventListener("change", handleBreakpoint);
}

const swiperMotivosEl = document.querySelector(".swiper-motivos");
if (swiperMotivosEl) {
  initSwiperMotivos();
}

const swiperInstagram = new Swiper(".swiperInstagram", {
  // Optional parameters
  slidesPerView: "auto",
  direction: "horizontal",
  spaceBetween: 12,
  centerInsufficientSlides: true,
  breakpoints: {
    992: {
      spaceBetween: 40,
    },
  },
});

const swiperBanner = new Swiper(".swiper-banner-home", {
  // Optional parameters
  slidesPerView: "auto",
  direction: "horizontal",
  // centeredSlides: true,
  centerInsufficientSlides: true,
  effect: "fade", // Ativa o efeito de fade
  fadeEffect: {
    crossFade: true, // Suaviza a transição entre o slide atual e o próximo
  },
  // loop: true,

  // Navigation arrows
  pagination: {
    el: ".swiper-navigation.hero .swiper-pagination",
    clickable: true,
  },
  // Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

const swiperParceiros = new Swiper(".swiper-parceiros", {
  slidesPerView: "auto",
  direction: "horizontal",
  centerInsufficientSlides: true,
});

/* -------------------------------------------------------------------------- */
/*        Sticky background mask da seção "Porque Escolher"                   */
/*        O ::before começa em top: 0 e depois de 100px de scroll             */
/*        dentro da seção, compensa o scroll para ficar "travado"             */
/* -------------------------------------------------------------------------- */

(function () {
  const section = document.querySelector(".section-home-porque-escolher");
  if (!section || typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;

  const OFFSET = 100; // pixels do topo da seção antes de "travar"

  ScrollTrigger.create({
    trigger: section,
    start: "top+=" + OFFSET + " top", // dispara quando 100px do topo da seção alcançam o topo da viewport
    end: "bottom bottom",
    onUpdate: (self) => {
      // self.progress é sempre entre 0 e 1, o que garante que o delta seja
      // limitado ao tamanho exato da área de trigger. Isso evita o bug onde
      // o pattern vaza para fora da seção quando a página é carregada lá embaixo.
      const delta = (self.end - self.start) * self.progress;
      section.style.setProperty("--bg-offset-y", delta + "px");
    },
  });
})();
